import { PatientId } from "../../messages";

export const primaryPhysicianQueryKey = (patientId: PatientId) => [
  "patient",
  patientId,
  "physician",
];

export const allPhysiciansQueryKey = (patientId: PatientId) => [
  "patient",
  patientId,
  "all-physicians",
];
